<template>
  <div class="page-content">
    <div class="mx-1">
    </div>
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h4>Workspaces</h4>
            <div class="row d-flex justify-content-between align-items-center pt-3">
              <div class="col-6 col-sm-6">
                <form class="search-form" @submit.prevent="page = 1; searchWorkspace()">
                  <div class="input-group border rounded-sm">
                    <div class="input-group-prepend">
                      <div class="input-group-text border-0 rounded-sm">
                        <FeatherIcon type="search" class="icon-md cursor-pointer" />
                      </div>
                    </div>
                    <input v-model="workspaceName" type="text" class="form-control  border-0 rounded-sm" id="searchForm" placeholder="Search by workspace name">
                  </div>
                </form>
              </div>
              <div class="col-6 col-sm-6">
                <el-select class="w-100" id="reseller" @change="page = 1; searchWorkspace()" clearable v-model="workspaceReseller" placeholder="Choose Reseller">
                  <!-- <el-option key="all_reseller" label="Choose Reseller" value=""></el-option> -->
                  <el-option v-for="(rsl, i) in reseller" :key="i" :label="rsl.text" :value="rsl.value"></el-option>
                  <el-option key="not_reseller" label="Not Reseller" value="not_reseller"></el-option>
                </el-select>
              </div>
              <div class="col-3 col-sm-3 mt-1">
                <el-select class="w-100" id="status" @change="page = 1; searchWorkspace()" clearable v-model="workspaceStatus" placeholder="Choose Status">
                  <!-- <el-option key="all" label="All Status" value=""></el-option> -->
                  <el-option key="active" label="Active" value="active"></el-option>
                  <el-option key="idle" label="Idle" value="idle"></el-option>
                  <el-option key="waiting" label="Waiting" value="waiting"></el-option>
                  <el-option key="suspend" label="Suspend/Blocked" value="suspend"></el-option>
                  <el-option key="offboard" label="Offboard" value="offboard"></el-option>
                </el-select>
              </div>
              <div class="col-3 col-sm-3 mt-1">
                <el-select class="w-100" id="pic" @change="page = 1; searchWorkspace()" clearable v-model="workspacePIC" placeholder="Choose PIC">
                  <!-- <el-option key="all" label="All PIC" value=""></el-option> -->
                  <el-option v-for="(pic, i) in picList" :key="i" :label="pic.text" :value="pic.value"></el-option>
                </el-select>
              </div>
              <div class="col-3 col-sm-3 mt-1">
                <el-select class="w-100" id="subs_period" @change="page = 1; searchWorkspace()" clearable v-model="workspaceSubscription" placeholder="Choose Subs Period">
                  <!-- <el-option key="all" label="All Subscription" value=""></el-option> -->
                  <el-option key="year" label="Yearly" value="year"></el-option>
                  <el-option key="month" label="Monthly" value="month"></el-option>
                  <el-option key="not_set" label="Not Set" value="not_set"></el-option>
                </el-select>
              </div>
              <div class="col-3 col-sm-3 mt-1">
                <el-select class="w-100" id="package" @change="page = 1; searchWorkspace()" clearable v-model="workspacePackage" placeholder="Choose Package">
                  <!-- <el-option key="all" label="All Package" value=""></el-option> -->
                  <el-option v-for="(pd, i) in product" :key="i" :label="pd.text" :value="pd.value"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Company Name</th>
                    <th>Status</th>
                    <th>Package Plan</th>
                    <th>PIC Name</th>
                    <th>Payment Method</th>
                    <th>Created At</th>
                    <th>Approved At</th>
                    <!-- <th>Marketing Conv</th>
                    <th>Marketing Lite Conv</th>
                    <th>Utility Conv</th>
                    <th>Authentication Conv</th> -->
                    <th>Marketing Message Price</th>
                    <th>Marketing Lite Message Price</th>
                    <th>Utility Message Price</th>
                    <th>Authentication Message Price</th>
                    <th>Service Conv</th>
                    <th>Call</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(workspace, i) in workspaceList" :key="i">
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      {{ workspace.name }}
                      <!-- <Status :online="workspace.status == 'active'" /> -->
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      {{ workspace.company_name }} ({{ workspace.company_brand }})
                    </td>
                    <td class="text-capitalize">
                      <Status :online="workspace.status == 'active'" />
                      <span class="ml-2">{{ workspace.status }}</span>
                      <p v-if="workspace.invoicing_info?.offboarded" class="text-danger" style="font-size: .75em">Offboarded <br>{{ moment(workspace.invoicing_info?.offboarded_at).format('DD MMM YYYY') }}</p>
                      <p v-else-if="workspace.channels?.length > 0" class="text-danger" style="font-size: .75em">Suspended <br>{{moment(workspace.channels[0].configuration.blocked_at).format('DD MMM YYYY') }}</p>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <el-tag effect="dark" size="mini" :type="tagColor[workspace.products[0].name]">
                        {{ workspace.products ? workspace.products[0].name : '-' }}
                      </el-tag>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">{{ workspace.pic && workspace.pic.full_name ? workspace.pic.full_name : '-' }}</td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span class="ml-2">{{ workspace.products[0].is_postpaid ? 'Post Paid' : 'Pre Paid' }}</span>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">{{ moment(workspace.created_at).format('DD MMM YYYY, HH:mm') }}</td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">{{ workspace.approved_at ? moment(workspace.approved_at).format('DD MMM YYYY, HH:mm') : ''  }}</td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span v-if="workspace.products[0].pricing && workspace.products[0].pricing.whatsapp && workspace.products[0].pricing.whatsapp.marketing_message">
                        Rp.{{ workspace.products[0].pricing.whatsapp.marketing_message }}
                      </span>
                      <span v-else>Not Set</span>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span v-if="workspace.products[0].pricing && workspace.products[0].pricing.whatsapp && workspace.products[0].pricing.whatsapp.marketing_lite_message">
                        Rp.{{ workspace.products[0].pricing.whatsapp.marketing_lite_message }}
                      </span>
                      <span v-else>Not Set</span>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span v-if="workspace.products[0].pricing && workspace.products[0].pricing.whatsapp && workspace.products[0].pricing.whatsapp.utility_message">
                        Rp.{{ workspace.products[0].pricing.whatsapp.utility_message }}
                      </span>
                      <span v-else>Not Set</span>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span v-if="workspace.products[0].pricing && workspace.products[0].pricing.whatsapp && workspace.products[0].pricing.whatsapp.authentication_message">
                        Rp.{{ workspace.products[0].pricing.whatsapp.authentication_message }}
                      </span>
                      <span v-else>Not Set</span>
                    </td>
                    <td @click="setWorkspace(workspace)" class="cursor-pointer">
                      <span v-if="workspace.products[0].pricing && workspace.products[0].pricing.whatsapp && (workspace.products[0].pricing.whatsapp.service_message ?? workspace.products[0].pricing.whatsapp.service_conversation) != null">
                        Rp.{{ workspace.products[0].pricing.whatsapp.service_message ?? workspace.products[0].pricing.whatsapp.service_conversation }}
                      </span>
                      <span v-else>Not Set</span>
                    </td>
                    <td>{{ displayStatusCallFeature(workspace.products[0].pricing) }}</td>
                    <td class="text-capitalize">
                      <el-dropdown trigger="hover" @command="commandHandler($event, workspace)">
                        <el-button type="primary" size="small">
                          Actions<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="copyWorkspaceId">
                            Copy Workspace ID
                          </el-dropdown-item>
                          <el-dropdown-item command="setWorkspace" v-if="checkPermission.read">
                            Manage Workspace
                          </el-dropdown-item>
                          <el-dropdown-item command="editWorkspace" v-if="checkPermission.update && ['idle','active'].includes(workspace.status)">
                            Edit
                          </el-dropdown-item>
                          <el-dropdown-item command="editSubscription" v-if="checkPermission.update && ['idle','active'].includes(workspace.status)">
                            Subscription
                          </el-dropdown-item>
                          <el-dropdown-item command="addDeals" v-if="checkPermission.update && ['idle','active'].includes(workspace.status) && workspace.products[0].platform_subscription">
                            Add Deals
                          </el-dropdown-item>
                          <el-dropdown-item command="handlerApprovedBtn" v-if="workspace.status=='waiting' && checkPermission.update">
                            Approve
                          </el-dropdown-item>
                          <el-dropdown-item command="handlerOffboardBtn" v-if="workspace.status=='active' && ['finance', 'admin', 'customer service'].includes(checkUser.role.name.toLowerCase())
                            && (!workspace.invoicing_info || !workspace.invoicing_info?.offboarded)">
                            Offboard
                          </el-dropdown-item>
                          <el-dropdown-item command="handlerReOnboardBtn" v-else-if="workspace.status=='active' && ['admin'].includes(checkUser.role.name.toLowerCase())">
                            Re-Onboard
                          </el-dropdown-item>
                          <el-dropdown-item command="postpaidWorkspace" v-if="checkPermission.update">
                            {{ workspace.products[0].is_postpaid ? 'Disabled Post Paid' : 'Enable Post Paid' }}
                          </el-dropdown-item>
                          <el-dropdown-item command="doEnableCallFeature" v-if="checkPermission.update && enableWhatsappCall(workspace)">
                            {{ workspace.products[0].pricing.whatsapp.enable_call_feature ? 'Disabled Call Feature' : 'Enable Call Feature' }}
                          </el-dropdown-item>
                          <el-dropdown-item command="doEnableVideoCallFeature" v-if="checkPermission.update && enableWhatsappVideoCall(workspace)">
                            {{ workspace.products[0].pricing.whatsapp.enable_video_call_feature ? 'Disabled Video Call Feature' : 'Enable Video Call Feature' }}
                          </el-dropdown-item>
                          <el-dropdown-item command="chooseBotProduct" v-if="['tech', 'bussiness', 'admin'].includes(checkUser.role.name.toLowerCase()) && workspace.status === 'active'">
                            {{ !workspace.custom_detail[0]?.features?.bot_builder ? 'Connect to AI Kit' : (workspace.custom_detail[0]?.features?.bot_builder === true ? 'Disabled AI Kit' : 'Enable AI Kit') }}
                          </el-dropdown-item>
                          <el-dropdown-item command="editCustomBot" v-if="['tech', 'admin'].includes(checkUser.role.name.toLowerCase()) && workspace.status === 'active'">
                            Edit Custom Bot
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-pagination
                :page-size="20"
                layout="prev, pager, next"
                :total="dataTotal"
                :current-page="parseInt(page)"
                @current-change="changePage">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showModalEdit" :title="`Edit Workspace ${form.name}`" hide-footer @hide="closeModal" @reset="closeModal">
      <b-form @reset="closeModal" class="p-2">
        <el-steps :active="active_step" finish-status="success">
          <el-step v-for="(step, idx) in list_steps" :title="step" :key="`step_${idx}`"></el-step>
        </el-steps>

        <div class="mt-4">
          <div v-if="list_steps[active_step] === 'Information'">
            <b-form-group id="ws-name-group" label="Workspace Name:" label-for="ws-name">
              <b-form-input id="ws-name" v-model="form.name" type="text" placeholder="Enter workspace name" required />
            </b-form-group>
            <b-form-group label="Approval" v-if="checkPermission.update && (checkUser.role.name.toLowerCase() === 'admin' || (checkUser.role_id.toLowerCase() !== '2e673799-d373-4872-a3e1-05fbb3e419e4' && checkUser.id === approved_by))">
              <b-form-group id="ws-pic" label="PIC Workspace : " label-for="ws-pic">
                <b-form-select id="ws-pic" required v-model="approval.pic_id" :options="picList" />
              </b-form-group>
            </b-form-group>
          </div>
          <div v-if="list_steps[active_step] === 'Whatsapp'">
            <b-row>
              <b-col>
                <b-form-group label="Authentication Conv Price" label-for="auth_conv_price">
                  <b-form-input id="auth_conv_price" :disabled="true" v-model="pricing.authentication_conversation" label="Authentication Conv Price:" type="number" placeholder="Authentication Conv Price" step=".01" required/>
                </b-form-group>
                <b-form-group label="Marketing Conv Price" label-for="marketing_conv_price">
                  <b-form-input id="marketing_conv_price" :disabled="true" v-model="pricing.marketing_conversation" label="Marketing Conv Price:" type="number" placeholder="Marketing Conv Price" step=".01" required/>
                </b-form-group>
                <b-form-group v-if="pricing.marketing_lite" label="Marketing Lite Conv Price" label-for="marketing_lite_conv_price">
                  <b-form-input id="marketing_lite_conv_price" :disabled="true" v-model="pricing.marketing_lite_conversation" label="Marketing Lite Conv Price:" type="number" placeholder="Marketing Lite Conv Price" step=".01"/>
                </b-form-group>
                <b-form-group label="Utility Conv Price" label-for="util_conv_price">
                  <b-form-input id="util_conv_price" :disabled="true" v-model="pricing.utility_conversation" label="Utility Conv Price:" type="number" placeholder="Utility Conv Price" step=".01" required/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Authentication Price Per Message" label-for="auth_price">
                  <b-form-input id="auth_price" v-model="pricing.authentication" label="Authentication Price Per Message:" type="number" placeholder="Authentication Price Per Message" step=".01" required/>
                </b-form-group>
                <b-form-group label="Marketing Price Per Message" label-for="marketing_price">
                  <b-form-input id="marketing_price" v-model="pricing.marketing" label="Marketing Price Per Message:" type="number" placeholder="Marketing Price Per Message" step=".01" required/>
                </b-form-group>
                <b-form-group v-if="pricing.marketing_lite" label="Marketing Lite Price Per Message" label-for="marketing_lite_price">
                  <b-form-input id="marketing_lite_price" v-model="pricing.marketing_lite" label="Marketing Lite Price Per Message:" type="number" placeholder="Marketing Lite Price Per Message" step=".01"/>
                </b-form-group>
                <b-form-group label="Utility Price Per Message" label-for="util_price">
                  <b-form-input id="util_price" v-model="pricing.utility" label="Utility Price Per Message:" type="number" placeholder="Utility Price Per Message" step=".01" required/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Service Price" label-for="service_price">
              <b-form-input id="service_price" v-model="pricing.service" label="Service Price:" type="number" placeholder="Service Price" step=".01" required/>
            </b-form-group>
            <b-row>
              <b-col>
                <b-form-group label="WhatsApp Inbound Call Price" label-for="whatsapp_incoming_call_price">
                  <b-form-input id="whatsapp_incoming_call_price" v-model="pricing.whatsapp.incoming_call" label="Inbound Call Price:" type="number" placeholder="WhatsApp Inbound Call Price" step=".01" required/>
                </b-form-group>
                <b-form-group label="WhatsApp Inbound Video Call Price" label-for="whatsapp_incoming_video_call_price">
                  <b-form-input id="whatsapp_incoming_video_call_price" v-model="pricing.whatsapp.incoming_video_call" label="Inbound Video Call Price:" type="number" placeholder="WhatsApp Inbound Video Call Price" step=".01" required/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="WhatsApp Outbond Call Price" label-for="whatsapp_outgoing_call_price">
                  <b-form-input id="whatsapp_outgoing_call_price" v-model="pricing.whatsapp.outgoing_call" label="Outbond Call Price:" type="number" placeholder="WhatsApp Outbond Call Price" step=".01" required/>
                </b-form-group>
                <b-form-group label="WhatsApp Outbond Video Call Price" label-for="whatsapp_outgoing_video_call_price">
                  <b-form-input id="whatsapp_outgoing_video_call_price" v-model="pricing.whatsapp.outgoing_video_call" label="Outbond Video Call Price:" type="number" placeholder="WhatsApp Outbond Video Call Price" step=".01" required/>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-form-group label="Ticket Base Charing" label-for="ticket_base_charing">
              <b-form-input id="ticket_base_charing" v-model="pricing.ticket_base_charing" label="Ticket Base Charing Price:" type="number" placeholder="Ticket Base Charing Price" step=".01" required/>
            </b-form-group> -->
            <b-row class="mb-2">
              <b-col>
                <b-button variant="outline-primary" @click="addCountry('whatsapp')" class="align-items-center"><FeatherIcon type="plus" class="icon-xs" /> International Pricing</b-button>
              </b-col>
            </b-row>
            <b-row v-for="(itl, idx) in pricing.whatsapp.international" :key="`whatsapp_${idx}`" class="mt-2">
              <b-col>
                <div variant="primary" class="d-flex justify-content-between align-items-center toggle-collapse" aria-expanded="false">
                  <p><b>{{ getCountryByCode(itl.country) }}</b></p>
                  <div style="font-size: 20px;">
                    <b-button v-b-toggle="`collapse-whatsapp-${idx}`" variant="outline-primary" class="p-1 mr-1"><FeatherIcon type="edit" class="icon-sm cursor-pointer" /></b-button>
                    <b-button variant="outline-danger" class="p-1" @click="removeCountry('whatsapp', idx)"><FeatherIcon type="trash" class="icon-sm cursor-pointer" /></b-button>
                  </div>
                </div>
                <b-collapse :id="`collapse-whatsapp-${idx}`" class="mt-2">
                  <b-form-select v-model="itl.country" placeholder="Choose Country" size="sm" required>
                    <b-form-select-option :value="null" disabled>Choose Country</b-form-select-option>
                    <b-form-select-option v-for="(country, index) in country_code" :key="index" :value="country.dial_code">{{ country.name }}</b-form-select-option>
                  </b-form-select>
                  <b-form-group class="mt-2">
                    <b-row>
                      <b-col>
                        <b-form-group label="Authentication Price Per Message">
                          <b-form-input v-model="itl.authentication" label="Authentication Price Per Message:" type="number" placeholder="Authentication Price Per Message" step=".01" required/>
                        </b-form-group>
                        <b-form-group label="Utility Price Per Message">
                          <b-form-input v-model="itl.utility" label="Utility Price Per Message:" type="number" placeholder="Utility Price Per Message" step=".01" required/>
                        </b-form-group>
                        <b-form-group label="Marketing Price Per Message">
                          <b-form-input v-model="itl.marketing" label="Marketing Price Per Message:" type="number" placeholder="Marketing Price Per Message" step=".01" required/>
                        </b-form-group>
                        <b-form-group v-if="pricing.marketing_lite" label="Marketing Lite Price Per Message">
                          <b-form-input v-model="itl.marketing_lite" label="Marketing Lite Price Per Message:" type="number" placeholder="Marketing Lite Price Per Message" step=".01"/>
                        </b-form-group>
                        <b-form-group label="Service Price">
                          <b-form-input v-model="itl.service" label="Service Price:" type="number" placeholder="Service Price" step=".01" required/>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="WhatsApp Outbond Call Price">
                          <b-form-input v-model="itl.outgoing_call" label="Outbond Call Price:" type="number" placeholder="WhatsApp Outbond Call Price" step=".01" required/>
                        </b-form-group>
                        <b-form-group label="WhatsApp Inbound Call Price">
                          <b-form-input v-model="itl.incoming_call" label="Inbound Call Price:" type="number" placeholder="WhatsApp Inbound Call Price" step=".01" required/>
                        </b-form-group>
                        <b-form-group label="WhatsApp Outbond Video Call Price">
                          <b-form-input v-model="itl.outgoing_video_call" label="Outbond Video Call Price:" type="number" placeholder="WhatsApp Outbond Video Call Price" step=".01" required/>
                        </b-form-group>
                        <b-form-group label="WhatsApp Inbound Video Call Price">
                          <b-form-input v-model="itl.incoming_video_call" label="Inbound Video Call Price:" type="number" placeholder="WhatsApp Inbound Video Call Price" step=".01" required/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-collapse>
              </b-col>
            </b-row>
          </div>
          <div v-if="list_steps[active_step] === 'VoIP'">
            <b-row>
              <b-col>
                <b-form-group label="Phone Inbound Call Price" label-for="phone_call_incoming_call_price">
                  <b-form-input :disabled="pricing?.phone_call?.enable_feature ? false : true" id="phone_call_incoming_call_price" v-model="pricing.phone_call.incoming_call" label="Inbound Call Price:" type="number" placeholder="Phone Inbound Call Price" step=".01" required/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Phone Outbond Call Price" label-for="phone_call_outgoing_call_price">
                  <b-form-input :disabled="pricing?.phone_call?.enable_feature ? false : true" id="phone_call_outgoing_call_price" v-model="pricing.phone_call.outgoing_call" label="Outbond Call Price:" type="number" placeholder="Phone Outbond Call Price" step=".01" required/>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-if="list_steps[active_step] === 'AI Studio'">
            <b-row>
              <b-col>
                <b-form-group label="AI Studio Session Price" label-for="ai_studio_session_price">
                  <b-form-input id="ai_studio_session_price" v-model="pricing.ai_studio.session" label="AI Studio Session Price:" type="number" placeholder="Default 500 excl. PPN. Isi 0 untuk gratis" step=".01"/>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-if="list_steps[active_step] === 'SMS'">
            <b-form-group v-for="(provider, idx) in sms_provider" :key="`provider_${idx}`" :label="`${capitalize(provider)} Provider`">
              <b-row>
                <b-col>
                  <b-form-group label="Regular" :label-for="`${provider}_regular_price`">
                    <b-form-input :id="`${provider}_regular_price`" :value="displaySmsProvider(provider, 'regular')" @input="inputSmsProvider(provider, 'regular', $event)" :label="`${capitalize(provider)} Regular Price:`" type="number" :placeholder="`${capitalize(provider)} Regular Price`" step=".01" required/>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="OTP" :label-for="`${provider}_otp_price`">
                    <b-form-input :id="`${provider}_otp_price`" :value="displaySmsProvider(provider, 'otp')" @input="inputSmsProvider(provider, 'otp', $event)" :label="`${capitalize(provider)} OTP Price:`" type="number" :placeholder="`${capitalize(provider)} OTP Price`" step=".01" required/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-row class="mb-2">
              <b-col>
                <b-button variant="outline-primary" @click="addCountry('sms')" class="align-items-center"><FeatherIcon type="plus" class="icon-xs" /> International Pricing</b-button>
              </b-col>
            </b-row>
            <b-row v-for="(itl, idx) in pricing.sms.international" :key="idx" class="mt-2">
              <b-col>
                <div variant="primary" class="d-flex justify-content-between align-items-center toggle-collapse" aria-expanded="false">
                  <p><b>{{ getCountryByCode(itl.country) }}</b></p>
                  <div style="font-size: 20px;">
                    <b-button v-b-toggle="`collapse-sms-${idx}`" variant="outline-primary" class="p-1 mr-1"><FeatherIcon type="edit" class="icon-sm cursor-pointer" /></b-button>
                    <b-button variant="outline-danger" class="p-1" @click="removeCountry('sms', idx)"><FeatherIcon type="trash" class="icon-sm cursor-pointer" /></b-button>
                  </div>
                </div>
                <b-collapse :id="`collapse-sms-${idx}`" class="mt-2">
                  <b-form-select v-model="itl.country" placeholder="Choose Country" size="sm" required>
                    <b-form-select-option :value="null" disabled>Choose Country</b-form-select-option>
                    <b-form-select-option v-for="(country, index) in country_code" :key="index" :value="country.dial_code">{{ country.name }}</b-form-select-option>
                  </b-form-select>
                  <b-form-group class="mt-2">
                    <b-row>
                      <b-col>
                        <b-form-group label="Regular" >
                          <b-form-input v-model="itl.regular" type="number" size="sm" :placeholder="`${getCountryByCode(itl.country)} Regular Price`" step=".01" required/>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="OTP">
                          <b-form-input v-model="itl.otp" type="number" size="sm" :placeholder="`${getCountryByCode(itl.country)} OTP Price`" step=".01" required/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-collapse>
              </b-col>
            </b-row>
          </div>
          <hr/>
        </div>
        <div class="d-flex justify-content-between">
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
          <div class="d-flex flex-row-reverse">
            <b-button v-if="list_steps.length === (active_step+1)" type="button" @click="saveEdit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
            <b-button v-else type="button" variant="primary" class="ml-2" @click="() => active_step++">Next</b-button>
            <b-button v-if="active_step > 0" type="button" variant="secondary" class="ml-2" @click="() => active_step--">Back</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="showModalSubs" :title="`Edit Subscription ${form.name} For Period ${this_year}`" hide-footer @hide="closeModal">
      <b-form @submit.prevent="saveSubs" @reset="closeModal">
        <b-form-group label-class="font-weight-bold pt-0" label="Platform Subscription Pricing">
          <b-row>
            <b-form-group class="col-md-6" id="ws-plan" label="Package Plan" label-for="ws-plan">
              <b-form-select id="ws-plan" @change="choosePackage" placeholder="Choose subscription package" v-model="approvalForm.plan" :options="product" :disabled="form_subs_disabled" />
            </b-form-group>
            <b-form-group class="col-md-6" id="ws-period" label="Renewal Period : " label-for="ws-period">
              <b-form-select id="ws-period" @change="choosePackage" v-model="platform_subscription.subscription_period" :options="subs_period.filter((v) => v.value !== 'lifetime')" :disabled="form_subs_disabled" />
            </b-form-group>
            <b-form-group class="col-md-6" v-if="platform_subscription.subscription_period == 'month'" label="Biling Cycle in Month" label-for="platform-subscription-month">
              <b-form-select id="ws-subs-month" @input="getTotal" v-model="platform_subscription.subscription_lifetime" placeholder="Input biling cycle month" :disabled="form_subs_disabled" required>
                <b-form-select-option v-for="(index) in 11" :key="index" :value="index">{{ index }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group class="col-md-6" label="Biling Start Date" label-for="platform-subscription-date">
              <b-form-input id="ws-subs-date" v-model="platform_subscription.subscription_date" max="28" min="1" type="number" placeholder="Set billing date" :disabled="form_subs_disabled || is_subs_exists" required/>
            </b-form-group>
            <b-form-group class="col-md-6" v-if="platform_subscription.status == 'new'" label="Biling Start Month" label-for="platform-subscription-start-month">
              <b-form-select id="ws-subs-month" v-model="platform_subscription.subscription_month" placeholder="Set biling month" :disabled="form_subs_disabled" required>
                <b-form-select-option v-for="(index) in 12" :key="index" :value="index">{{ start_month[index-1] }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group class="col-md-6" v-if="platform_subscription.status == 'new'" label="Billing Period" label-for="platform-subscription-year">
              <b-form-select id="ws-subs-year" v-model="platform_subscription.subscription_year" placeholder="Choose billing period" required>
                <b-form-select-option value="2026">2026</b-form-select-option>
                <b-form-select-option value="2025">2025</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-4" label="Billing Type" label-for="ws-manual-invoice">
              <b-form-checkbox id="ws-manual-invoice" class="subs-switch" switch v-model="approvalForm.invoicing_info.is_manual">Invoice</b-form-checkbox>
              <span style="font-size:12px;" class="text-muted">Enable if manual billing</span>
            </b-form-group>
            <b-form-group class="col-md-3" label="Client Type" label-for="ws-reseller-check">
              <b-form-checkbox id="ws-reseller-check" switch v-model="approvalForm.invoicing_info.is_reseller">Reseller</b-form-checkbox>
            </b-form-group>
            <b-form-group class="col-md-5" label="New Invoice" label-for="ws-send_invoice-check">
              <b-form-checkbox id="ws-send_invoice-check" class="subs-switch" switch v-model="approvalForm.invoicing_info.send_invoice">Email to Client</b-form-checkbox>
              <span style="font-size:12px;" class="text-muted">Disable if billing already paid for this</span>
            </b-form-group>
            <b-form-group class="col-md-6" v-if="approvalForm.invoicing_info.is_reseller === true" label="Reseller Invoicing Type" label-for="ws-reseller-type">
              <b-form-select id="ws-reseller-type" v-model="approvalForm.invoicing_info.type" :options="reseller_type" />
            </b-form-group>
            <b-form-group class="col-md-6" v-if="approvalForm.invoicing_info.is_reseller === true" label="Choose Reseller" label-for="ws-reseller-id">
              <b-form-select id="ws-reseller-id" v-model="approvalForm.invoicing_info.reseller_id" placeholder="Choose reseller" :options="reseller" />
            </b-form-group>
          </b-row>
          <b-row class="d-flex justify-content-sm-start align-items-end">
            <div class="col-md-12">
              <label class="mr-2">Finance Email (Client Side)</label>
              <b-button variant="primary" size="xs" class="p-1" @click="addEmail()">Add</b-button>
            </div>
          </b-row>
          <b-row
            v-for="(email, idx) in approvalForm.invoicing_info.reseller_email" :key="idx"
            class="d-flex justify-content-sm-start align-items-end"
          >
            <b-form-group class="col-md-11">
              <b-form-input v-model="approvalForm.invoicing_info.reseller_email[idx]" placeholder="Input email to send billing"/>
            </b-form-group>
            <b-form-group class="col-md-1">
              <b-button variant="danger" size="xs" class="p-1" @click="removeEmail(idx)"><FeatherIcon type="trash" class="icon-xs" /></b-button>
            </b-form-group>
          </b-row>
          <b-row v-if="approvalForm.invoicing_info.is_reseller !== true">
            <b-form-group class="col-md-12" label="Company Invoice Name" label-for="ws-company-name">
              <b-form-input id="ws-company-name" v-model="approvalForm.invoicing_info.company_name" placeholder="Input name of company invoice"/>
            </b-form-group>
            <b-form-group class="col-md-12" label="Company Invoice Address" label-for="ws-company-address">
              <b-form-textarea rows="4" id="ws-company-address" v-model="approvalForm.invoicing_info.company_address" placeholder="Input address of company invoice"/>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" label="Pricing">
              <b-form-input @input="getTotal" v-model="platform_subscription.subscription_price" placeholder="Input price" step=".01" v-money="currency_mask" :disabled="form_subs_disabled" required/>
              <span class="text-muted">Pricing in a {{ platform_subscription.subscription_period }}</span>
            </b-form-group>
            <b-form-group class="col-md-6" label="Total price">
              <b-form-input disabled placeholder="Total price" step=".01" :value="Number(platform_subscription.subscription_total).toLocaleString('id-ID')" required/>
              <span class="text-muted">Price after discount</span>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" label="Discount type" >
              <select @change="getTotal" class="form-select rounded-sm" v-model="platform_subscription.discount_type" :disabled="form_subs_disabled" >
                <option value="percentage">Percentage</option>
                <option value="price">Price</option>
              </select>
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'price'" class="col-md-6" label="Discount price (Rp)">
              <b-form-input min="0" @input="getTotal" v-model="platform_subscription.discount_price" v-money="currency_mask" placeholder="Input discount" step=".01" :disabled="form_subs_disabled" />
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'percentage'" class="col-md-6" label="Discount percentage (%)">
              <b-form-input min="0" @input="getTotal" v-model="platform_subscription.discount_percentage" v-money="currency_mask" placeholder="Input discount" :disabled="form_subs_disabled" />
            </b-form-group>
          </b-row>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="showModalDeals" size="xl" :title="`List Deals ${form.name}`" hide-footer @hide="closeModal">
      <b-form @submit.prevent="saveDeals" @reset="closeModal">
        <b-row class="px-4 pb-3">
          <b-button variant="primary" @click="appendDeals()"> Add Deals </b-button>
        </b-row>
        <b-row class="p-2 flex-nowrap overflow-auto" v-for="(item, i) in deals_form" :key="i">
          <b-form-group class="col-md-3" id="ws-plan" label="Type : " label-for="ws-plan">
            <b-form-select id="ws-plan" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" @change="chooseDeals(item)" placeholder="Choose deals type" v-model="item.type" :options="deals_type" />
          </b-form-group>
          <b-form-group v-if="item.type === 'custom'" class="col-md-3" label="Name" label-for="platform-subscription-name-configuration">
              <b-form-input v-model="item.name" label="Name:" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" type="text" placeholder="Input name for custom deals" required/>
          </b-form-group>
          <b-form-group v-if="item.type === 'custom_lifetime'" class="col-md-3" label="Name">
              <el-select :key="i" class="w-100 mt-1" v-model="item.name" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" placeholder="Select your custom one time">
                <el-option v-for="(cs_lifetime, idx_cs_lifetime) in custom_lifetime" :key="idx_cs_lifetime" :value="cs_lifetime" />
              </el-select>
          </b-form-group>
          <b-form-group v-if="item.type === 'custom_monthly'" class="col-md-3" label="Name">
              <el-select :key="i" class="w-100 mt-1" v-model="item.name" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" placeholder="Select your custom monthly">
                <el-option v-for="(cs_monthly, idx_cs_monthly) in custom_monthly" :key="idx_cs_monthly" :value="cs_monthly" />
              </el-select>
          </b-form-group>
          <!-- <b-form-group class="col-md-2" id="ws-period" label="Renewal Period : " label-for="ws-period">
            <b-form-select id="ws-period" @change="choosePackage" v-model="item.period" :options="subs_period" />
          </b-form-group>
          <b-form-group class="col-md-2" v-if="item.period == 'month'" label="Biling Month" label-for="platform-subscription-month">
            <b-form-input id="ws-subs-month" v-model="item.lifetime" max="12" min="1" type="number" placeholder="Input biling month" required/>
          </b-form-group>

          <b-form-group v-if="item.period !== 'lifetime'" class="col-md-2" label="Biling Date" label-for="platform-subscription-date">
            <b-form-input id="ws-subs-date" v-model="item.date" max="28" min="1" type="number" placeholder="Input biling date" required/>
          </b-form-group> -->

          <b-form-group class="col-md-3" :label="`Pricing in one ${item.period == 'lifetime' ? 'time' : item.period}`" label-for="platform-subscription-pricing">
            <b-form-input :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" label="Platform subscription pricing:" type="text" v-model="item.price" placeholder="Input pricing deals" step=".01" v-money="currency_mask" required/>
          </b-form-group>
          <b-form-group class="col-md-3" v-if="item.name === 'Top Up Usage'" label="Qty" label-for="platform-subscription-qty">
            <b-form-input v-model="item.qty" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" label="Qty:" type="number" min="0" placeholder="" required/>
          </b-form-group>
          <b-form-group v-if="item.name === 'Top Up Usage'" class="col-md-3" label="Total Price" label-for="platform-subscription-pricing-total">
            <b-form-input disabled label="Platform subscription pricing:" type="text" :value="getTotalPrice(item.qty, item.price)" step=".01" v-money="currency_mask" required/>
          </b-form-group>
          <b-form-group v-if="!['custom_lifetime', 'custom_monthly'].includes(item.type) && item.lifetime > 1" class="col-md-3" label="Total Price" label-for="platform-subscription-pricing-total">
            <b-form-input disabled label="Platform subscription pricing:" type="text" :value="getTotalPrice(item.lifetime, item.price)" step=".01" v-money="currency_mask" required/>
          </b-form-group>
          <b-form-group class="col-md-2" v-if="['Top Up Balance', 'Top Up Usage'].includes(item.name)" label="VAT Exempt" label-for="platform-subscription-exc-ppn">
            <b-form-checkbox type="text" switch v-model="item.exc_ppn"/>
          </b-form-group>
          <template v-if="['Agent', 'Agent Group', 'Whatsapp Flow'].includes(item.name)">
            <b-form-group class="col-md-3" label="Limit" label-for="platform-subscription-pricing" style="width: calc(150%)">
              <b-form-input v-model="item.limit" :disabled="item._id && form_subs_disabled ? form_subs_disabled : false" label="Limit:" type="number" min="0" placeholder="" required/>
            </b-form-group>
          </template>
          <template v-else>
            <b-form-group class="col-md-3" label="Remarks" label-for="platform-subscription-pricing" style="width: calc(150%)">
              <b-form-input v-model="item.remarks" label="remarks:" type="text" placeholder="" required/>
            </b-form-group>
          </template>
          <b-form-group v-if="(i > 0 && !item._id) || (item._id && !form_subs_disabled)" class="col-md-1 text-align-center">
            <b-button variant="danger" class="mt-4 p-1" @click="removeDeals(i, item._id)"><FeatherIcon type="trash" class="icon-md cursor-pointer" /></b-button>
          </b-form-group>
        </b-row>
        <hr/>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal centered v-model="showModalApprove" :title="`Form Approval ${form.name}`" hide-footer @hide="handlerHideModalApprove">
      <h5 class="text-center">
        Are you sure want to approve this workspace?
      </h5>
      <p class="mb-4 text-center">
        You can not undo this action.
      </p>
      <b-form>
        <b-form-group id="ws-pic" label="PIC Workspace : " label-for="ws-pic">
          <b-form-select id="ws-pic" v-model="approvalForm.pic_id" :options="picList" required />
        </b-form-group>
        <b-form-group
          id="document-add-file_path"
          label="Attachment Quotation : "
          label-for="document-add-file_path">
          <b-form-file
            ref="addDocumentFile"
            v-model="approvalForm.file_path"
            :accept="accepted_ext['document']"
            placeholder="Choose a file or drop it here."
            drop-placeholder="Drop file here."
          ></b-form-file>
        </b-form-group>
        <b-form-group
          id="document-add-file_path-npwp"
          label="Attachment NPWP : "
          label-for="document-add-file_path-npwp">
          <b-form-file
            ref="addDocumentFile"
            v-model="approvalForm.file_path_npwp"
            :accept="accepted_ext['image']"
            placeholder="Choose a file or drop it here."
            drop-placeholder="Drop file here."
          ></b-form-file>
        </b-form-group>
        <hr/>
        <b-form-group label-class="font-weight-bold pt-0" label="Platform Subscription Pricing">
          <b-row>
            <b-form-group class="col-md-6" id="ws-plan" label="Package Plan : " label-for="ws-plan">
              <b-form-select id="ws-plan" @change="choosePackage" placeholder="Choose subscription package" v-model="approvalForm.plan" :options="product" />
            </b-form-group>
            <b-form-group class="col-md-6" id="ws-period" label="Renewal Period : " label-for="ws-period">
              <b-form-select id="ws-period" @change="choosePackage" v-model="platform_subscription.subscription_period" :options="subs_period.filter((v) => v.value !== 'lifetime')" />
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-4" v-if="platform_subscription.subscription_period == 'month'" label="Biling Cycle in Month" label-for="platform-subscription-month">
              <b-form-select id="ws-subs-month" @input="getTotal" v-model="platform_subscription.subscription_lifetime" placeholder="Set billing cycle month" required>
                <b-form-select-option v-for="(index) in 11" :key="index" :value="index">{{ index }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group class="col-md-4" label="Biling Start Date" label-for="platform-subscription-date">
              <b-form-input id="ws-subs-date" v-model="platform_subscription.subscription_date" max="28" min="1" type="number" placeholder="Set billing date" required/>
            </b-form-group>
            <b-form-group class="col-md-4" label="Biling Start Month" label-for="platform-subscription-start-month">
              <b-form-select id="ws-subs-month" v-model="platform_subscription.subscription_month" placeholder="Input biling start month" required>
                <b-form-select-option v-for="(index) in list_month_billing" :key="index" :value="index">{{ start_month[index-1] }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-4" label="Billing Type" label-for="ws-manual-invoice">
              <b-form-checkbox id="ws-manual-invoice" class="subs-switch" switch v-model="approvalForm.invoicing_info.is_manual">Invoice</b-form-checkbox>
              <span style="font-size:12px;" class="text-muted">Enable if manual billing</span>
            </b-form-group>
            <b-form-group class="col-md-8" label="Client Type" label-for="ws-reseller-check">
              <b-form-checkbox id="ws-reseller-check" switch v-model="approvalForm.invoicing_info.is_reseller">Reseller</b-form-checkbox>
            </b-form-group>
            <b-form-group class="col-md-6" v-if="approvalForm.invoicing_info.is_reseller === true" label="Reseller Invoicing Type" label-for="ws-reseller-type">
              <b-form-select id="ws-reseller-type" v-model="approvalForm.invoicing_info.type" :options="reseller_type" />
            </b-form-group>
            <b-form-group class="col-md-6" v-if="approvalForm.invoicing_info.is_reseller === true" label="Choose Reseller" label-for="ws-reseller-id">
              <b-form-select id="ws-reseller-id" v-model="approvalForm.invoicing_info.reseller_id" placeholder="Choose reseller" :options="reseller" />
            </b-form-group>
          </b-row>
          <b-row class="d-flex justify-content-sm-start align-items-end">
            <div class="col-md-12">
              <label class="mr-2">Finance Email (Client Side)</label>
              <b-button variant="primary" size="xs" class="p-1" @click="addEmail()">Add</b-button>
            </div>
          </b-row>
          <b-row
            v-for="(email, idx) in approvalForm.invoicing_info.reseller_email" :key="idx"
            class="d-flex justify-content-sm-start align-items-end"
          >
            <b-form-group class="col-md-11">
              <b-form-input v-model="approvalForm.invoicing_info.reseller_email[idx]" placeholder="Input email to send billing"/>
            </b-form-group>
            <b-form-group class="col-md-1">
              <b-button variant="danger" size="xs" class="p-1" @click="removeEmail(idx)"><FeatherIcon type="trash" class="icon-xs" /></b-button>
            </b-form-group>
          </b-row>
          <b-row v-if="approvalForm.invoicing_info.is_reseller !== true">
            <b-form-group class="col-md-12" label="Company Invoice Name" label-for="ws-company-name">
              <b-form-input id="ws-company-name" v-model="approvalForm.invoicing_info.company_name" placeholder="Input name of company invoice"/>
            </b-form-group>
            <b-form-group class="col-md-12" label="Company Invoice Address" label-for="ws-company-address">
              <b-form-textarea rows="4" id="ws-company-address" v-model="approvalForm.invoicing_info.company_address" placeholder="Input address of company invoice"/>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" :label="`Price in a ${platform_subscription.subscription_period}`">
              <b-form-input @input="getTotal" v-model="platform_subscription.subscription_price" placeholder="Input price" step=".01" v-money="currency_mask" required/>
            </b-form-group>
            <b-form-group class="col-md-6" label="Total Price">
              <b-form-input disabled :value="Number(platform_subscription.subscription_total).toLocaleString('id-ID')" placeholder="Total price" step=".01" required/>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" label="Discount type" >
              <select @change="getTotal" class="form-select rounded-sm" v-model="platform_subscription.discount_type">
                <option value="percentage">Percentage</option>
                <option value="price">Price</option>
              </select>
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'price'" class="col-md-6" label="Discount price (Rp)">
              <b-form-input @input="getTotal" v-model="platform_subscription.discount_price" v-money="currency_mask" placeholder="Input discount" step=".01"/>
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'percentage'" class="col-md-6" label="Discount percentage (%)">
              <b-form-input @input="getTotal" v-model="platform_subscription.discount_percentage" v-money="currency_mask" placeholder="Input discount"/>
            </b-form-group>
          </b-row>
          <!-- <b-row>
            <b-form-group class="col-md-6" label="Reseller">
              <el-radio-group class="w-100" v-model="platform_subscription.is_reseller" label="Reseller">
                <el-radio-button border :label="true">Yes</el-radio-button>
                <el-radio-button border :label="false">No</el-radio-button>
            </el-radio-group>
            </b-form-group>
            <b-form-group v-if="platform_subscription.is_reseller" class="col-md-6" label="Reseller Email">
              <b-form-input v-model="platform_subscription.reseller_email" type="text" placeholder="Input for reseller email"/>
            </b-form-group>
          </b-row> -->
        </b-form-group>
      </b-form>
      <hr/>
      <div class="mb-2 text-center">
        <el-button size="small" native-type="submit" :loading="loading.approveSubmit" @click="approveWorkspace" type="primary" class="mr-2">{{ $t('general.yes') }}</el-button>
        <el-button size="small" native-type="reset" @click="handlerHideModalApprove" type="info">{{ $t('general.no') }}</el-button>
      </div>
    </b-modal>

    <b-modal size="lg" v-model="showModalCustom" :title="`Edit Custom Bot ${form.name}`" hide-footer>
      <b-form @submit.prevent="saveCustomBot" @reset="closeModal">
        <b-form-group label="Webhook URL:" label-for="custom-webhook">
          <b-form-input id="custom-webhook" v-model="customForm.webhook" type="text" placeholder="Enter webhook" />
          <span v-if="!customForm.webhook && customForm._webhook" class="text-muted">Old webhook : {{ customForm._webhook }}</span>
        </b-form-group>
        <b-form-group label="Credential:" label-for="custom-credential">
          <b-form-input id="custom-credential" v-model="customForm.credential" type="text" placeholder="Enter credential" />
        </b-form-group>
        <b-form-group label="Webhook Data Type:" label-for="custom-webhook_type">
          <b-form-checkbox id="custom-webhook_type" switch v-model="customForm.webhook_type">Raw Data</b-form-checkbox>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal size="sm" v-model="showModalOffboard" :title="`Offboard ${form.name}`" hide-footer>
      <b-form @submit.prevent="saveOffboard" @reset="closeModal">
        <b-form-group label="Offboard Date:" label-for="offboard-date">
          <el-date-picker id="offboard-date" v-model="offboardForm.offboarded_date" type="date" placeholder="Choose date" required />
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>
<style>
#btn_link {
  background:none;border: none;color: #1e5b2a;
}
#btn_link:hover {
  text-decoration: underline;
  color: #143d1c;
}
.btn-search {
  margin-left: 1em;
}
.pageBox {
  background-color: #1e5b2a;
  color: white;
  padding: 0.5em 1em;
  margin: 0.5em 1em;
  cursor: pointer;
  border: 0;
}
.pageBox:hover {
  color: white;
}
</style>
<script>
import { VMoney } from 'v-money';
import { isMatch } from 'lodash';
import moment from 'moment';
import mime from 'mime';
import workspaceApi from '../../api/workspaces';
import popupErrorMessages from '../../library/popup-error-messages';
import country_code from '../../library/full-country-code.json';
import base64File from '../../library/base64File';
import documentAPI from '../../api/companyDocuments';
import wsProductAPI from '../../api/wsProducts';
import wsResellerAPI from '../../api/resellers';
import usersAPI from '../../api/userBackoffice';

export default {
  beforeCreate() {
    this.moment = moment;
  },
  name: 'Workspace',
  metaInfo: {
    title: 'Workspace',
  },
  directives: {
    money: VMoney,
  },
  data() {
    return {
      country_code,
      showModalEdit: false,
      showModalApprove: false,
      showModalSubs: false,
      showModalDeals: false,
      showModalCustom: false,
      showModalAIDashboard: false,
      showModalOffboard: false,
      workspaceName: this.$route.query.search || '',
      workspaceStatus: this.$route.query.status || '',
      workspaceSubscription: this.$route.query.subscription || '',
      workspacePIC: this.$route.query.pic_id || '',
      workspaceReseller: this.$route.query.reseller_id || '',
      workspacePackage: this.$route.query.product_id || '',
      dataSize: 0,
      dataTotal: 0,
      searchName: this.$route.query.search || '',
      page: this.$route.query.page || 1,
      workspaceList: [],
      tagColor: {
        'Basic Helpdesk': 'info',
        'Medium Package': '',
        'Large Package': 'warning',
        'Enterprice Package': 'success',
      },
      form: {
        name: '',
        ws_product_id: '',
      },
      deals_form: [
        {
          type: 'ai_assistance',
          period: 'month',
          lifetime: 1,
          date: '',
          price: '',
          limit: 0,
          remarks: '',
          exc_ppn: false,
          name: 'AI Assistance',
        },
      ],
      platform_subscription: {
        subscription_year: '2026',
        subscription_period: 'month',
        subscription_lifetime: 1, // month. used for billing cycle
        subscription_date: '',
        subscription_month: '',
        subscription_price: '0',
        subscription_total: '0',
        discount_type: '',
        discount_price: '0',
        discount_percentage: '0',
        status: '',
        is_reseller: false,
        reseller_email: null,
      },
      approvalForm: {
        pic_id: null,
        plan: '',
        file_path: null,
        file_path_npwp: null,
        invoicing_info: {
          is_manual: false,
          is_reseller: false,
          send_invoice: true,
          reseller_email: null,
          reseller_id: null,
          type: 'client',
          company_name: null,
          company_address: null,
        },
        company_name: null,
        company_address: null,
      },
      customForm: {
        webhook: '',
        _webhook: '',
        webhook_type: false,
        credential: '',
      },
      plan_choosen: {},
      approval: {
        pic_id: null,
        plan: '',
        // subscription_period: 'month',
        // subscription_lifetime: 1, // month. used for billing cycle
        // subscription_date: '',
        // subscription_price: '',
      },
      pricing: {
        utility: 0,
        authentication: 0,
        marketing: 0,
        service: 0,
        whatsapp: {
          enable_call_feature: null,
          incoming_call: null,
          outgoing_call: null,
          incoming_video_call: null,
          outgoing_video_call: null,
          international: null,
        },
        // WAP-406 — harga window AI Studio. Key-nya harus ada sejak awal supaya v-model
        // reaktif tanpa $set (Vue 2.7). null = pakai default 500, 0 = gratis.
        ai_studio: {
          session: null,
        },
        // phone_call: {
        //   enable_feature: null,
        //   incoming_call: null,
        //   outgoing_call: null,
        // },
        // sms: {},
        // ticket_base_charing: 0,
      },
      accepted_ext: {
        document: '.pdf, .xls, .xlsx, .docx, .doc, .csv, .ppt, .pptx, .txt',
        image: '.pdf, .jpeg, .png, .jpg',
      },
      picList: [],
      product: [],
      productBot: [],
      reseller: [],
      reseller_type: [
        {
          text: 'Direct Client',
          value: 'client',
        },
        {
          text: 'To Reseller',
          value: 'reseller',
        },
      ],
      dealsList: [],
      deals_type: [
        {
          text: 'AI Assistance',
          value: 'ai_assistance',
        },
        {
          text: 'AI Enterprise',
          value: 'ai_enterprise',
        },
        // {
        //   text: 'AI Additional Services',
        //   value: 'ai_additional_services',
        // },
        {
          text: 'Custom',
          value: 'custom',
          pricing: 0,
        },
        {
          text: 'Custom Onetime',
          value: 'custom_lifetime',
          pricing: 0,
        },
        {
          text: 'Custom Monthly',
          value: 'custom_monthly',
          pricing: 0,
        },
      ],
      subs_period: [
        {
          text: 'Monthly',
          value: 'month',
        },
        {
          text: 'Yearly',
          value: 'year',
        },
        {
          text: 'Onetime',
          value: 'lifetime',
        },
      ],
      loading: {
        approveSubmit: false,
        deals: false,
        AIDashboard: false,
      },
      editedId: '',
      loaderStack: 0,
      loader: null,
      workspace_id: '',
      active_workspace: {},
      company_id: '',
      billings: [],
      form_subs_disabled: false,
      is_subs_exists: false,
      start_month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      custom_lifetime: ['Whatsapp Flow', 'Setup Fee', 'AI Additional Service', 'Custom Development', 'Top Up Balance', 'Top Up Usage'],
      custom_monthly: ['Agent', 'Agent Group', 'AI Assistance', 'AI Enterprise', 'AI Additional Service'],
      currency_mask: {
        decimal: ',',
        thousands: '.',
        precision: 0,
      },
      list_month_billing: [parseInt(moment().format('M'), 0), (parseInt(moment().format('M'), 0) + 1)],
      this_year: moment().format('YYYY'),
      sms_provider: ['telkomsel', 'indosat', 'smartfren', 'xl', 'tri', 'other'],
      sms_international: ['telkomsel', 'indosat', 'smartfren', 'xl', 'tri', 'other'],
      active_step: 0,
      list_steps: [],
      offboardForm: {
        workspace_id: '',
        company_id: '',
        offboarded_date: moment().format('YYYY-MM-DD'),
      },
    };
  },
  async mounted() {
    this.searchWorkspace();
    this.loadPIC();
    this.loadReseller();
    this.loadProduct();
    this.dataTotal = this.$store.state.backOffice.companiesSize;
    this.dataSize = Math.ceil(this.$store.state.backOffice.companiesSize / 10);
  },
  computed: {
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
    checkUser() {
      return this.$store.state.backOffice.userProfile;
    },
  },
  components: {
    Status: () => import('../components/Status.vue'),
  },
  methods: {
    getTotalPrice(count, price) {
      const lifetime = parseInt(count, 0);
      const amount = parseInt(price.replace(/\D/g, ''), 0) || 0;
      return lifetime * amount;
    },
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    editCustomBot(workspace) {
      this.company_id = workspace.company_id;
      this.editedId = workspace._id;
      this.form.name = workspace.name;
      if (workspace.configuration?.custom_bot) {
        this.customForm.webhook = workspace.configuration.custom_bot.webhook;
        this.customForm._webhook = workspace.configuration.custom_bot._webhook;
        this.customForm.credential = workspace.configuration.custom_bot.reply_credentials?.password;
        if (workspace.configuration.custom_bot.webhook_type === 'raw') {
          this.customForm.webhook_type = true;
        }
      }
      this.showModalCustom = true;
    },
    enableWhatsappCall(workspace) {
      return workspace.products[0] && workspace.products[0].pricing && workspace.products[0].pricing.whatsapp
      && (workspace.products[0].pricing.whatsapp.incoming_call || workspace.products[0].pricing.whatsapp.incoming_call === 0) && workspace.products[0].pricing.whatsapp.outgoing_call
      && ['active'].includes(workspace.status);
    },
    enableWhatsappVideoCall(workspace) {
      return workspace.products[0] && workspace.products[0].pricing && workspace.products[0].pricing.whatsapp
      && (workspace.products[0].pricing.whatsapp.incoming_video_call || workspace.products[0].pricing.whatsapp.incoming_video_call === 0) && (workspace.products[0].pricing.whatsapp.outgoing_video_call || workspace.products[0].pricing.whatsapp.outgoing_video_call === 0)
      && ['active'].includes(workspace.status) && workspace.products[0].pricing.whatsapp.enable_call_feature;
    },
    copyWorkspaceId(workspace) {
      const copyText = workspace._id;
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText);
      this.$message('Copied to clipboard');
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    handlerHideModalApprove() {
      this.workspace_id = '';
      this.workspace_name = '';
      this.form.name = '';
      this.approvalForm = {
        pic_id: null,
        plan: '',
        file_path: null,
        file_path_npwp: null,
        invoicing_info: {
          is_manual: false,
          is_reseller: false,
          send_invoice: true,
          reseller_email: null,
          reseller_id: null,
          type: 'client',
          company_name: null,
          company_address: null,
        },
        company_name: null,
        company_address: null,
      };
      this.showModalApprove = false;
    },
    async approveWorkspace() {
      this.loading.approveSubmit = true;
      const fileName = this.approvalForm.file_path.name.toLowerCase();
      const fileExt = `.${mime.getExtension(this.approvalForm.file_path.type)}`;
      const type = 'document';
      if (fileName.includes('quotation') || fileName.includes('quo')) {
        const accepted_quotation = this.accepted_ext[type].split(',').map((v) => v.trim());
        if (!accepted_quotation.includes(fileExt)) {
          this.$message({
            message: this.$t('general.error.file_not_supported'),
            type: 'warning',
            duration: 10 * 1000,
          });
          return;
        }
        const fileExtNPWP = `.${mime.getExtension(this.approvalForm.file_path_npwp.type)}`;
        const type_npwp = 'image';
        const accepted_npwp = this.accepted_ext[type_npwp].split(',').map((v) => v.trim());
        if (!accepted_npwp.includes(fileExtNPWP)) {
          this.$message({
            message: this.$t('general.error.file_not_supported'),
            type: 'warning',
            duration: 10 * 1000,
          });
          return;
        }
        await this.createDocumentQuotation();
        await this.createDocumentNPWP();
        if (this.approvalForm.invoicing_info.is_reseller === true || this.approvalForm.invoicing_info.company_name === this.approvalForm.company_name) {
          delete this.approvalForm.invoicing_info.company_name;
        }
        if (this.approvalForm.invoicing_info.is_reseller === true || this.approvalForm.invoicing_info.company_address === this.approvalForm.company_address) {
          delete this.approvalForm.invoicing_info.company_address;
        }
        await workspaceApi.approval(
          this.workspace_id,
          this.company_id,
          {
            pic_id: this.approvalForm.pic_id,
            plan: this.approvalForm.plan,
            invoicing_info: this.approvalForm.invoicing_info,
            platform_subscription: this.platform_subscription,
          },
        ).then(async (response) => {
          await popupErrorMessages(response);
          this.loading.approveSubmit = false;
          this.$message({
            message: this.$t('workspace.success.approve'),
            type: 'success',
          });
          await this.searchWorkspace();
          this.handlerHideModalApprove();
        }).catch(() => {
          this.loading.approveSubmit = false;
        });
      } else {
        this.loading.approveSubmit = false;
        this.$message({
          message: this.$t('general.error.file_not_supported'),
          type: 'warning',
          duration: 10 * 1000,
        });
        return;
      }
      this.loading.approveSubmit = false;
    },
    async createDocumentQuotation() {
      const documentForm = {
        file_name: `Quotation ${this.workspace_name}`,
        category: 'Quotation',
        company_id: this.company_id,
        workspace_ids: [this.workspace_id],
      };
      documentForm.file = await base64File(this.approvalForm.file_path);
      const response = await documentAPI.createDocument(
        documentForm,
      ).catch(() => {});
      await popupErrorMessages(response);
      // this.$message({
      //   message: this.$t('workspace.success.approve'),
      //   type: 'success',
      // });
    },
    async createDocumentNPWP() {
      const documentForm = {
        file_name: `NPWP ${this.workspace_name}`,
        category: 'NPWP',
        company_id: this.company_id,
        workspace_ids: [this.workspace_id],
      };
      documentForm.file = await base64File(this.approvalForm.file_path_npwp);
      const response = await documentAPI.createDocument(
        documentForm,
      ).catch(() => {});
      await popupErrorMessages(response);
    },
    postpaidWorkspace(workspace) {
      this.$confirm(this.$t('workspace.confirm.postpaid'), 'Confirmation', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await workspaceApi.pricing_plan(workspace._id, workspace.company_id)
              .then(async (response) => {
                await popupErrorMessages(response);
                this.$message({
                  message: this.$t('workspace.success.postpaid'),
                  type: 'success',
                });
                this.searchWorkspace();
              });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    clearForm() {
      this.editedId = '';
      this.form.name = '';
      this.form.ws_product_id = '';
      this.platform_subscription = {
        subscription_year: '2026',
        subscription_period: 'month',
        subscription_lifetime: 1, // month. used for billing cycle
        subscription_date: '',
        subscription_month: '',
        subscription_price: '',
        discount_type: '',
        discount_price: 0,
        discount_percentage: 0,
        status: '',
      };
      this.deals_form = [
        {
          type: 'ai_assistance',
          period: 'month',
          lifetime: 1, // month. used for billing cycle
          date: '',
          price: '',
          qty: 0,
          limit: 0,
          remarks: '',
          exc_ppn: false,
          name: 'AI Assistance',
        },
      ];
      this.approvalForm = {
        pic_id: null,
        plan: '',
        file_path: null,
        file_path_npwp: null,
        invoicing_info: {
          is_manual: false,
          is_reseller: false,
          send_invoice: true,
          reseller_email: null,
          reseller_id: null,
          type: 'client',
          company_name: null,
          company_address: null,
        },
        company_name: null,
        company_address: null,
      };
      this.customForm = {
        webhook: '',
        _webhook: '',
        webhook_type: false,
        credential: '',
      };
    },
    closeModal() {
      this.showModal = false;
      this.showModalEdit = false;
      this.showModalSubs = false;
      this.showModalDeals = false;
      this.showModalCustom = false;
      this.form_subs_disabled = false;
      this.is_subs_exists = false;
      this.active_workspace = {};
      this.pricing = {
        utility: 0,
        authentication: 0,
        marketing: 0,
        service: 0,
        whatsapp: {
          enable_call_feature: null,
          incoming_call: null,
          outgoing_call: null,
          incoming_video_call: null,
          outgoing_video_call: null,
          international: null,
        },
        ai_studio: {
          session: null,
        },
      };
      this.clearForm();
    },
    async loadProduct() {
      await wsProductAPI.getList()
        .then((res) => {
          this.product = res.data.rows.map((item) => ({
            text: item.name,
            value: item._id,
            pricing: item.pricing,
          }));
        });
    },
    async loadBotProduct() {
      await wsProductAPI.getListBot()
        .then((res) => {
          this.productBot = res.data.data.map((item) => ({
            text: item.name,
            value: item.id,
          }));
        });
    },
    async loadReseller() {
      await wsResellerAPI.getList()
        .then((res) => {
          this.reseller = res.data.rows.map((item) => ({
            text: item.name,
            value: item._id,
          }));
        });
    },
    async loadPIC() {
      await usersAPI.getPIC()
        .then((res) => {
          this.picList = res.data.rows.map((item) => ({
            text: item.full_name,
            value: item.id,
          }));
        });
    },
    editWorkspace(workspace) {
      this.showLoader();
      this.editedId = workspace._id;
      this.form.name = workspace.name;
      this.approval.pic_id = workspace.pic_id;
      this.approval.plan = workspace.products[0]._id;
      this.approved_by = workspace.approved_by;
      if (workspace.products[0].is_postpaid !== undefined) {
        this.selected = workspace.products[0].is_postpaid === true ? 'postpaid' : 'prepaid';
      } else {
        this.selected = '';
      }
      if (workspace.products[0].pricing) {
        if (workspace.products[0].pricing.whatsapp) {
          const priceListWhatsapp = workspace.products[0].pricing.whatsapp;
          this.pricing.authentication_conversation = priceListWhatsapp.authentication_conversation;
          this.pricing.utility_conversation = priceListWhatsapp.utility_conversation;
          this.pricing.marketing_conversation = priceListWhatsapp.marketing_conversation;
          if (priceListWhatsapp.marketing_lite_conversation) {
            this.pricing.marketing_lite_conversation = priceListWhatsapp.marketing_lite_conversation;
          }
          this.pricing.authentication = priceListWhatsapp.authentication_message;
          this.pricing.utility = priceListWhatsapp.utility_message;
          this.pricing.marketing = priceListWhatsapp.marketing_message;
          if (priceListWhatsapp.marketing_lite_message) {
            this.pricing.marketing_lite = priceListWhatsapp.marketing_lite_message;
          }
          // service_message dipakai mulai 1 Okt 2026, fallback ke service_conversation
          // supaya workspace yang belum di-backfill tidak tampil kosong
          this.pricing.service = priceListWhatsapp.service_message ?? priceListWhatsapp.service_conversation;
          this.pricing.whatsapp.incoming_call = priceListWhatsapp.incoming_call;
          this.pricing.whatsapp.outgoing_call = priceListWhatsapp.outgoing_call;
          this.pricing.whatsapp.incoming_video_call = priceListWhatsapp.incoming_video_call;
          this.pricing.whatsapp.outgoing_video_call = priceListWhatsapp.outgoing_video_call;
          this.pricing.whatsapp.enable_call_feature = priceListWhatsapp.enable_call_feature;
          this.pricing.whatsapp.international = priceListWhatsapp.international;
        }
        if (workspace.products[0].pricing.phone_call) {
          const priceListPhone = workspace.products[0].pricing.phone_call;
          if (!this.pricing.phone_call) {
            this.pricing.phone_call = {};
          }
          this.pricing.phone_call.incoming_call = priceListPhone.incoming_call;
          this.pricing.phone_call.outgoing_call = priceListPhone.outgoing_call;
          this.pricing.phone_call.enable_feature = priceListPhone.enable_feature;
        }
        if (workspace.products[0].pricing.ai_studio) {
          this.pricing.ai_studio.session = workspace.products[0].pricing.ai_studio.session;
        }
        if (workspace.products[0].pricing.sms) {
          const priceListSms = workspace.products[0].pricing.sms;
          if (!priceListSms.domestic) {
            this.$set(priceListSms, 'domestic', []);
          }
          if (!priceListSms.international) {
            this.$set(priceListSms, 'international', []);
          }
          this.pricing.sms = priceListSms;
        }
      } else {
        this.pricing = {
          utility: 0,
          authentication: 0,
          marketing: 0,
          service: 0,
          whatsapp: {
            enable_call_feature: null,
            incoming_call: null,
            outgoing_call: null,
            incoming_video_call: null,
            outgoing_video_call: null,
            international: null,
          },
          ai_studio: {
            session: null,
          },
        };
      }
      this.active_step = 0;
      this.list_steps = ['Information', 'Whatsapp'];
      if (this.pricing?.phone_call) {
        this.list_steps.push('VoIP');
      }
      // Selalu tampil, beda dengan VoIP: default 500 berlaku untuk semua workspace, jadi
      // ops harus bisa lihat dan override tanpa menunggu object pricing-nya ada dulu.
      this.list_steps.push('AI Studio');
      if (this.pricing?.sms) {
        this.list_steps.push('SMS');
      }
      this.showModalEdit = true;
      this.hideLoader();
    },
    async saveEdit() {
      this.showLoader();
      const obj = {
        name: this.form.name,
        pricing: {
          utility: this.pricing.utility,
          authentication: this.pricing.authentication,
          marketing: this.pricing.marketing,
          service: this.pricing.service,
          whatsapp: {
            incoming_call: this.pricing.whatsapp.incoming_call,
            outgoing_call: this.pricing.whatsapp.outgoing_call,
            incoming_video_call: this.pricing.whatsapp.incoming_video_call,
            outgoing_video_call: this.pricing.whatsapp.outgoing_video_call,
            international: this.pricing.whatsapp.international,
          },
        },
        approval: this.approval,
      };
      if (this.pricing.marketing_lite) {
        obj.pricing.marketing_lite = this.pricing.marketing_lite;
      }
      if (this.pricing.phone_call) {
        obj.pricing.phone_call = {
          incoming_call: this.pricing.phone_call.incoming_call,
          outgoing_call: this.pricing.phone_call.outgoing_call,
        };
      }
      if (this.pricing.sms) {
        obj.pricing.sms = this.pricing.sms;
      }
      // Dikirim hanya kalau ops benar-benar mengisi. `0` valid dan berarti gratis,
      // jadi cek null/'' eksplisit, bukan truthy.
      if (this.pricing.ai_studio && this.pricing.ai_studio.session !== null && this.pricing.ai_studio.session !== '') {
        obj.pricing.ai_studio = { session: this.pricing.ai_studio.session };
      }
      const res = await workspaceApi.update(this.editedId, obj);
      await popupErrorMessages(res);
      this.$message({
        message: this.$t('workspace.success.edit'),
        type: 'success',
      });
      this.showModalEdit = false;
      this.active_step = 0;
      this.list_steps = ['Information', 'Whatsapp'];
      this.searchWorkspace();
      this.closeModal();
      this.hideLoader();
    },
    async saveSubs() {
      this.showLoader();
      if (this.approvalForm.invoicing_info.is_reseller === true || this.approvalForm.invoicing_info.company_name === this.approvalForm.company_name) {
        delete this.approvalForm.invoicing_info.company_name;
      }
      if (this.approvalForm.invoicing_info.is_reseller === true || this.approvalForm.invoicing_info.company_address === this.approvalForm.company_address) {
        delete this.approvalForm.invoicing_info.company_address;
      }
      await workspaceApi.subscription(
        this.editedId,
        this.company_id,
        {
          plan: this.approvalForm.plan,
          platform_subscription: this.platform_subscription,
          invoicing_info: this.approvalForm.invoicing_info,
        },
      ).then(async () => {
        this.$message({
          message: this.$t('workspace.success.edit'),
          type: 'success',
        });
        this.searchWorkspace();
        this.closeModal();
      });
      this.hideLoader();
    },
    async saveCustomBot() {
      await workspaceApi.updateCustomBot({
        id: this.editedId,
        company_id: this.company_id,
        data: this.customForm,
      }).then(async (res) => {
        await popupErrorMessages(res);
        this.$message({
          message: this.$t('workspace.success.edit'),
          type: 'success',
        });
        this.searchWorkspace();
        this.closeModal();
      });
    },
    async saveDeals() {
      this.showLoader();
      await workspaceApi.updateDeals({
        id: this.editedId,
        company_id: this.company_id,
        data: this.deals_form,
      }).then(async () => {
        this.$message({
          message: this.$t('workspace.success.edit'),
          type: 'success',
        });
        this.searchWorkspace();
        this.closeModal();
      });
      this.hideLoader();
    },
    dateConverter(date) {
      const createdAt = new Date(date);
      return `${createdAt.toLocaleDateString('id-ID')} ${createdAt.toLocaleTimeString('id-ID')}`;
    },
    async setWorkspace(workspace) {
      await this.$store.dispatch('company/setActiveCompany', { id: workspace.company_id });
      await this.$store.dispatch('backOffice/setActiveCompany', workspace.company_id);
      this.$store.dispatch('workspace/setActiveWorkspace', workspace)
        .then(() => {
          this.$router.push('/dashboard');
        });
    },
    async searchWorkspace() {
      const options = {
        page: this.page,
        search: this.workspaceName,
        status: this.workspaceStatus,
        subs_period: this.workspaceSubscription,
        pic_id: this.workspacePIC,
        reseller_id: this.workspaceReseller,
        product_id: this.workspacePackage,
      };

      if (!isMatch(this.$route.query, options)) {
        this.$router.replace({ query: options });
      }
      console.log('Reload...');
      const loader = this.$loading.show();
      const response = await workspaceApi.getAllWorkspaces(options);
      if (!response.error) {
        this.workspaceList = response.data.rows;
        this.dataTotal = response.data.total;
      }
      loader.hide();
    },
    async changePage(currentPage) {
      this.page = currentPage;
      this.searchWorkspace();
    },
    doEnableCallFeature(workspace) {
      this.$confirm(this.$t('workspace.confirm.call_feature'), 'Confirmation', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const response = await workspaceApi.updateCallFeature({
              id: workspace._id,
              company_id: workspace.company_id,
              data: {
                enable_call_feature: !workspace.products[0].pricing.whatsapp.enable_call_feature,
              },
            });
            instance.confirmButtonLoading = false;
            try {
              await popupErrorMessages(response);
              this.$message({
                message: this.$t('workspace.success.edit'),
                type: 'success',
              });
            } catch (error) {
              console.log(error);
            }
            this.searchWorkspace();
          }
          cb();
        },
      }).catch(() => {});
    },
    doEnableVideoCallFeature(workspace) {
      this.$confirm(this.$t('workspace.confirm.call_feature'), 'Confirmation', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const response = await workspaceApi.updateCallFeature({
              id: workspace._id,
              company_id: workspace.company_id,
              data: {
                enable_call_feature: !workspace.products[0].pricing.whatsapp.enable_video_call_feature,
                video: true,
              },
            });
            instance.confirmButtonLoading = false;
            try {
              await popupErrorMessages(response);
              this.$message({
                message: this.$t('workspace.success.edit'),
                type: 'success',
              });
            } catch (error) {
              console.log(error);
            }
            this.searchWorkspace();
          }
          cb();
        },
      }).catch(() => {});
    },
    async chooseBotProduct(workspace) {
      this.doEnableAIDashboard(workspace);
    },
    doEnableAIDashboard(workspace) {
      let status = 'Connect';
      if (workspace.custom_detail[0]?.features?.bot_builder === true) {
        status = 'Disable';
      } else if (workspace.custom_detail[0]?.features?.bot_builder === false) {
        status = 'Enable';
      }
      this.$confirm(this.$t('workspace.confirm.ai_dashboard').replace('{{status}}', status).replace('{{name}}', workspace.name), 'Confirmation', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            this.loading.AIDashboard = true;
            instance.confirmButtonLoading = true;
            const response = await workspaceApi.connectAIDashboard({
              id: workspace._id,
              company_id: workspace.company_id,
            });
            instance.confirmButtonLoading = false;
            this.loading.AIDashboard = false;
            await popupErrorMessages(response);
            this.$message({
              message: this.$t('workspace.success.edit'),
              type: 'success',
            });
            this.searchWorkspace();
          }
          cb();
        },
      }).catch(async (err) => {
        await popupErrorMessages(err);
      });
    },
    commandHandler($event, workspace) {
      if (this[$event]) this[$event](workspace);
    },
    handlerApprovedBtn(workspace) {
      this.workspace_id = workspace._id;
      this.form.name = workspace.name;
      this.company_id = workspace.company_id;
      this.workspace_name = workspace.name;
      this.approvalForm.pic_id = workspace.pic_id;
      this.approvalForm.plan = workspace.products[0]._id;
      this.approvalForm.company_name = workspace.company_name;
      this.approvalForm.company_address = workspace.company_address;
      this.approvalForm.invoicing_info.company_name = workspace.company_name;
      this.approvalForm.invoicing_info.company_address = workspace.company_address;
      this.approvalForm.invoicing_info.reseller_email = [null];
      this.plan_choosen = workspace.products[0];
      this.platform_subscription = {
        subscription_year: '2026',
        subscription_period: 'month',
        subscription_lifetime: 1, // month. used for billing cycle
        subscription_date: '',
        subscription_month: '',
        subscription_price: String(Number(workspace.products[0].pricing.base_price || 0)),
        subscription_total: String(Number(workspace.products[0].pricing.base_price || 0)),
        discount_type: '',
        discount_price: '0',
        discount_percentage: '0',
        status: '',
      };
      this.showModalApprove = true;
    },
    handlerOffboardBtn(workspace) {
      if (workspace.invoicing_info?.offboarded) {
        return;
      }
      this.showModalOffboard = true;
      this.offboardForm.workspace_id = workspace._id;
      this.offboardForm.company_id = workspace.company_id;
    },
    saveOffboard() {
      this.$confirm('Are you sure to change status workspace?', 'Offboard this workspace?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await workspaceApi.offboarding(this.offboardForm)
              .then(async (response) => {
                instance.confirmButtonLoading = false;
                await popupErrorMessages(response);
                this.$message({
                  message: 'Successfully offboarding workspace',
                  type: 'success',
                });
                this.showModalOffboard = false;
                this.searchWorkspace();
              });
          }
          cb();
        },
      }).catch(() => {});
    },
    async editSubscription(workspace) {
      this.editedId = workspace._id;
      this.form.name = workspace.name;
      await this.loadBillings(workspace);
      this.approvalForm.plan = workspace.products[0]._id;
      if (workspace.invoicing_info) {
        this.approvalForm.company_name = workspace.company_name;
        this.approvalForm.company_address = workspace.company_address;
        this.approvalForm.invoicing_info.is_manual = workspace.invoicing_info.is_manual;
        this.approvalForm.invoicing_info.is_reseller = workspace.invoicing_info.is_reseller;
        this.approvalForm.invoicing_info.send_invoice = workspace.invoicing_info.send_invoice ?? true;
        this.approvalForm.invoicing_info.reseller_id = workspace.invoicing_info.reseller_id;
        this.approvalForm.invoicing_info.type = workspace.invoicing_info.type;
        this.approvalForm.invoicing_info.reseller_email = workspace.invoicing_info.reseller_email;
      } else {
        workspace.invoicing_info = {
          reseller_email: null,
        };
      }
      if (!Array.isArray(workspace.invoicing_info.reseller_email)) {
        this.approvalForm.invoicing_info.reseller_email = [workspace.invoicing_info.reseller_email];
      }
      this.approvalForm.invoicing_info.company_name = workspace.invoicing_info?.company_name || workspace.company_name;
      this.approvalForm.invoicing_info.company_address = workspace.invoicing_info?.company_address || workspace.company_address;
      if (workspace.products[0].platform_subscription) {
        this.platform_subscription = {
          subscription_year: workspace.products[0].platform_subscription.subscription_year,
          subscription_period: workspace.products[0].platform_subscription.subscription_period,
          subscription_lifetime: workspace.products[0].platform_subscription.subscription_lifetime, // month. used for billing cycle
          subscription_date: workspace.products[0].platform_subscription.subscription_date,
          subscription_month: workspace.products[0].platform_subscription.subscription_month,
          subscription_price: String(workspace.products[0].platform_subscription.subscription_price),
          discount_type: workspace.products[0].platform_subscription.discount_type,
          discount_price: String(workspace.products[0].platform_subscription.discount_price),
          discount_percentage: String(workspace.products[0].platform_subscription.discount_percentage),
          subscription_total: String(workspace.products[0].platform_subscription.subscription_total),
          status: '',
        };
      } else {
        this.platform_subscription = {
          subscription_year: '2026',
          subscription_period: 'month',
          subscription_lifetime: 1, // month. used for billing cycle
          subscription_date: '',
          subscription_month: '',
          subscription_price: String(workspace.products[0].pricing.base_price || 0),
          discount_type: '',
          discount_price: '0',
          discount_percentage: '0',
          subscription_total: '0',
          status: 'new',
        };
      }
      this.company_id = workspace.company_id;
      this.showModalSubs = true;
    },
    async loadBillings(workspace) {
      await workspaceApi.getBillings(workspace._id, workspace.company_id)
        .then((res) => {
          if (res.data.billings.length === 0) return;
          if (workspace.invoicing_info?.offboarded) return;
          this.form_subs_disabled = res.data.billings.some((item) => item.status === 'waiting_payment');
          this.is_subs_exists = res.data.billings.some((billing) => billing.billing_details?.some((detail) => detail.type === 'Platform Subscription'));
          this.billings = res.data.billings;
        });
    },
    async addDeals(workspace) {
      this.editedId = workspace._id;
      this.form.name = workspace.name;
      this.approvalForm.plan = workspace.products[0]._id;
      await this.loadDeals(workspace);
      await this.loadBillings(workspace);
      this.active_workspace = workspace;
      this.company_id = workspace.company_id;
      this.showModalDeals = true;
    },
    async loadDeals(workspace) {
      await workspaceApi.getDeals(workspace._id, workspace.company_id)
        .then((res) => {
          if (res.data.deals.length === 0) {
            this.deals_form[0].period = workspace.products[0].platform_subscription?.subscription_period;
            this.deals_form[0].date = workspace.products[0].platform_subscription?.subscription_date;
            this.deals_form[0].lifetime = workspace.products[0].platform_subscription?.subscription_lifetime;
            return;
          }

          this.deals_form = res.data.deals.map((deal) => ({
            _id: deal._id,
            type: deal.type,
            lifetime: deal.subscription.lifetime,
            date: deal.subscription.date,
            price: deal.configuration.name === 'Top Up Usage' ? String(deal.configuration.qty_price) : String(deal.subscription.price),
            qty: deal.configuration?.qty ?? 0,
            period: deal.subscription.period,
            limit: deal.configuration?.limit ?? 0,
            remarks: deal.configuration?.remarks ?? '',
            exc_ppn: deal.subscription.exc_ppn ?? false,
            name: deal.configuration?.name ?? '',
          }));
        });
    },
    choosePackage() {
      if (this.approvalForm.plan) {
        const product = this.product.find((v) => v.value === this.approvalForm.plan);
        if (product && product.pricing) {
          if (this.platform_subscription.subscription_period === 'month') {
            this.platform_subscription.subscription_price = product.pricing.base_price;
          } else if (this.platform_subscription.subscription_period === 'year') {
            this.platform_subscription.subscription_price = product.pricing.annual_price;
          }
        }
        this.getTotal();
      }
    },
    chooseDeals(item) {
      item.name = '';
      if (item.type === 'custom_lifetime') {
        item.period = 'lifetime';
      } else if (item.type === 'custom_monthly') {
        item.period = 'month';
      } else {
        if (item.type === 'ai_assistance') {
          item.name = 'AI Assistance';
        } else if (item.type === 'ai_enterprise') {
          item.name = 'AI Enterprise';
        }
        item.lifetime = this.active_workspace.products[0].platform_subscription.subscription_lifetime;
        item.period = this.active_workspace.products[0].platform_subscription.subscription_period;
      }
      return item;
    },
    getTotal() {
      let price = 0;
      this.platform_subscription.subscription_price = String(this.platform_subscription.subscription_price).replace(/\D/g, '');
      this.platform_subscription.discount_price = String(this.platform_subscription.discount_price).replace(/\D/g, '');
      this.platform_subscription.discount_percentage = String(this.platform_subscription.discount_percentage).replace(/\D/g, '');
      if (!this.platform_subscription.subscription_price) {
        this.platform_subscription.subscription_price = 0;
      }
      if (this.platform_subscription.subscription_period === 'month') {
        price = parseInt(this.platform_subscription.subscription_price, 0) * parseInt(this.platform_subscription.subscription_lifetime, 0);
      } else if (this.platform_subscription.subscription_period === 'year') {
        price = parseInt(this.platform_subscription.subscription_price, 0);
      }
      let discount_price = 0;
      if (this.platform_subscription.discount_type === 'percentage') {
        discount_price = Math.ceil(parseFloat((price * parseInt(this.platform_subscription.discount_percentage, 0)) / 100));
      } else if (this.platform_subscription.discount_type === 'price') {
        discount_price = Number(this.platform_subscription.discount_price);
      }
      this.platform_subscription.subscription_total = String(Number(price - discount_price));
    },
    appendDeals() {
      this.deals_form.push({
        type: 'ai_assistance',
        period: this.active_workspace.products[0].platform_subscription.subscription_period,
        lifetime: this.active_workspace.products[0].platform_subscription.subscription_lifetime,
        date: this.active_workspace.products[0].platform_subscription.subscription_date,
        price: '',
        limit: 0,
        qty: 0,
        exc_ppn: false,
        name: 'AI Assistance',
      });
    },
    removeDeals(idx, id) {
      if (!id) {
        this.deals_form.splice(idx, 1);
        return;
      }
      this.$confirm('Are you sure to delete this deals?', 'Delete this deals?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
      }).then(async () => {
        this.loading.deals = true;
        await workspaceApi.deleteDeals(
          {
            id: this.editedId,
            company_id: this.company_id,
            deals_id: id,
          },
        ).then(async (resp) => {
          if (!resp.error) {
            this.deals_form.splice(idx, 1);
            this.$message({
              type: 'success',
              message: 'Successfully delete deals',
            });
          } else {
            this.$message({
              type: 'error',
              message: resp.error.message || 'Something wrong, please try again.',
            });
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.message || 'Something wrong, please try again.',
          });
        });
      }).catch(() => {});
    },
    displayStatusCallFeature(pricing) {
      if (pricing?.whatsapp?.enable_call_feature && pricing?.phone_call?.enable_feature) {
        return 'WhatsApp & Voip';
      } if (pricing?.whatsapp?.enable_call_feature) {
        return 'WhatsApp';
      } if (pricing?.phone_call?.enable_feature) {
        return 'Voip';
      }
      return 'Disable';
    },
    inputSmsProvider(provider, category, value) {
      const idx = this.pricing.sms.domestic.findIndex((v) => v.provider === provider);
      if (idx === -1) {
        this.pricing.sms.domestic.push({
          provider,
          [category]: value,
        });
        return;
      }
      this.$set(this.pricing.sms.domestic[idx], category, value);
    },
    displaySmsProvider(provider, category) {
      if (this.pricing.sms.domestic) {
        const item = this.pricing.sms.domestic.find((v) => v.provider === provider);
        return item?.[category] ?? 0;
      }
      return null;
    },
    addCountry(channel) {
      console.log(this.pricing[channel].international);
      if (!this.pricing[channel].international) {
        this.pricing[channel].international = [];
      }
      if (channel === 'sms') {
        this.pricing.sms.international.push({
          country: null,
          regular: null,
          otp: null,
        });
      } else if (channel === 'whatsapp') {
        this.pricing.whatsapp.international.push({
          country: null,
          service: null,
          utility: null,
          authentication: null,
          marketing: null,
          marketing_lite: null,
          incoming_call: null,
          outgoing_call: null,
          incoming_video_call: null,
          outgoing_video_call: null,
        });
      }
    },
    getCountryByCode(code) {
      if (code) {
        const country = this.country_code.find((v) => v.dial_code === code);
        if (country) {
          return `${country.name} Pricing`;
        }
      }
      return 'Choose Country';
    },
    removeCountry(channel, idx) {
      this.pricing[channel].international.splice(idx, 1);
    },
    addEmail() {
      this.approvalForm.invoicing_info.reseller_email.push(null);
    },
    removeEmail(idx) {
      this.approvalForm.invoicing_info.reseller_email.splice(idx, 1);
    },
    handlerReOnboardBtn(item) {
      this.$confirm(`Are you sure to Re-Onboarding and Activate ${item.name} workspace? New billing will be create and send to client`, 'Activate this workspace?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await workspaceApi.re_onboarding({
              workspace_id: item._id,
              company_id: item.company_id,
            }).then(async (response) => {
              instance.confirmButtonLoading = false;
              await popupErrorMessages(response);
              this.$message({
                type: 'success',
                message: 'Successfully re-onboarding workspace',
              });
              this.searchWorkspace();
            }).catch(async (err) => {
              instance.confirmButtonLoading = false;
              await popupErrorMessages(err);
            });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
  },
};
</script>

<style>
.toggle-collapse[aria-expanded="true"] .mdi-chevron-down {
  display: none;
}

.toggle-collapse[aria-expanded="false"] .mdi-chevron-up {
  display: none;
}

.subs-switch.custom-control.custom-switch {
  margin-bottom: -10px !important;
}
</style>
